import { call, put, select, takeLatest } from 'redux-saga/effects';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { setErrorCode } from '../redux/Actions/ErrorAction';
import { PLACES_AUTOCOMPLETE_ACTION, PLACES_AUTOCOMPLETE_SUCCESS, PLACES_AUTOCOMPLETE_ERROR, PLACES_GEOLOCATION_ACTION, PLACES_GEOLOCATION_SUCCESS, PLACES_GEOLOCATION_ERROR, PLACES_AUTOCOMPLETE_CLEAR, PLACES_REVERSE_GEOCODE_ACTION, PLACES_REVERSE_GEOCODE_SUCCESS, PLACES_REVERSE_GEOCODE_FAILURE, X_AKAMAI_ORIGIN, KFC_RENEGADE_GOOGLE_PLACES, } from '../constants';
import { parseAddress } from '../utils/AddressParser';
export const tenantReducerSelector = (state) => {
    return state?.tenantReducer;
};
const headers = {
    [X_AKAMAI_ORIGIN]: KFC_RENEGADE_GOOGLE_PLACES,
};
export function* placesAutocompleteCall(data) {
    try {
        const { payload } = data;
        let countries = [];
        payload.countryCode?.forEach((code) => {
            countries.push(`country:${code}`);
        });
        const components = countries.join('|');
        const queryData = {
            queryProps: {
                components,
                key: payload.key,
                country: payload.country,
                input: payload.query,
                types: payload.types ? payload.types : [],
            },
        };
        const { response, status } = yield call(invokeApi, networkConfig.placesAutocomplete, queryData, headers);
        if (response && response !== undefined && response !== null) {
            yield put({
                type: PLACES_AUTOCOMPLETE_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: PLACES_AUTOCOMPLETE_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: PLACES_AUTOCOMPLETE_ERROR,
        });
    }
}
export function* placesGeolocationCall(data) {
    try {
        const { payload } = data;
        const queryData = {
            queryProps: { key: payload.key, place_id: payload.placeId },
        };
        const { response, status } = yield call(invokeApi, networkConfig.placesGeolocation, queryData, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response !== undefined && response !== null) {
            const { deliveryAddressMapping = {} } = yield select(tenantReducerSelector);
            const deliveryAddress = parseAddress(response.results[0].address_components, deliveryAddressMapping);
            yield put({
                type: PLACES_GEOLOCATION_SUCCESS,
                response,
                deliveryAddress,
            });
        }
        else {
            yield put({
                type: PLACES_GEOLOCATION_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: PLACES_GEOLOCATION_ERROR,
        });
    }
}
export function* clearListCall() {
    yield put({
        type: PLACES_AUTOCOMPLETE_CLEAR,
    });
}
export function* getAddressCall(data) {
    try {
        const { payload } = data;
        const address = payload.lat + ',' + payload.lng;
        const queryData = { queryProps: { key: payload.key, address: address } };
        const { response, status } = yield call(invokeApi, networkConfig.reverseGeocode, queryData, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response && response !== undefined && response !== null) {
            const { deliveryAddressMapping = {} } = yield select(tenantReducerSelector);
            const deliveryAddress = parseAddress(response.results[0].address_components, deliveryAddressMapping);
            yield put({
                type: PLACES_REVERSE_GEOCODE_SUCCESS,
                response,
                deliveryAddress,
            });
        }
        else {
            yield put({
                type: PLACES_REVERSE_GEOCODE_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: PLACES_REVERSE_GEOCODE_FAILURE,
        });
    }
}
export function* placesAutocompleteSaga() {
    yield takeLatest(PLACES_AUTOCOMPLETE_ACTION, placesAutocompleteCall);
}
export function* placesGeolocationSaga() {
    yield takeLatest(PLACES_GEOLOCATION_ACTION, placesGeolocationCall);
}
export function* clearList() {
    yield takeLatest(PLACES_AUTOCOMPLETE_CLEAR, clearListCall);
}
export function* getAddressSaga() {
    yield takeLatest(PLACES_REVERSE_GEOCODE_ACTION, getAddressCall);
}
